<template>
    <div class="mb-5" v-if="current_fulfillment_requests.employer_name">
        <h4 class="mb-3">
            {{ current_fulfillment_requests.employer_name }} 
            <template v-if="current_fulfillment_requests.campaign_name">
                / {{ current_fulfillment_requests.campaign_name }} 
            </template>
            Fulfillment Requests
        </h4>

        <p v-if="current_fulfillment_requests.list.length == 0">
            No Fulfillment Requests found
        </p>
        <div class="table-responsive" style="max-height: 450px" v-else>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Campaign</th>
                        <th class="tb-la">Filled/Ordered</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr :row="f" v-for="f in current_fulfillment_requests.list" :key="f.id" style="font-size: 14px">
                        <td>{{ f.requested_for_formatted }}</td>
                        <td>{{ f.campaign_name }}</td>
                        <td class="tb-la">{{ f.leads_delivered }} / {{ f.leads_ordered }}</td>
                        <td>
                            <a :href="url(`/admin/driver-engage/fulfillment/${f.id}`)">Detail</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>

    export default {
        props: [
            "current_fulfillment_requests"
        ],
        components: {
        },
        data() {
            return {
            }
        },
        watch: {
        },
        computed: {
        },
        methods: {
            
        },
        mounted() {
        },
        created() {
        },
    }
</script>